import { render, staticRenderFns } from "./PaginationSidebar.vue?vue&type=template&id=39598464&"
import script from "./PaginationSidebar.vue?vue&type=script&lang=js&"
export * from "./PaginationSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PaginationSidebar.vue?vue&type=style&index=0&id=39598464&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports